"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@uirouter/angular");
const viewGlossary_component_1 = require("./components/viewGlossary.component");
exports.states = [
    {
        name: "viewGlossary",
        url: "/glossary/viewGlossary",
        component: viewGlossary_component_1.ViewGlossaryComponent
    }
];
